// API KEY を保存するクッキーの名前
export const COOKIE_NAME_FOR_API_KEY = 'api-key';

// API KEY を保存するクッキーの有効期間（日）
export const COOKIE_EXPIRES_FOR_API_KEY = 1;

// API にアクセスするときの API-KEY のヘッダー名
export const HEADER_NAME_FOR_API_KEY = 'X-API-KEY';

// クライアント側の言語を指定する API-KEY のヘッダー名
export const HEADER_NAME_FOR_LANGUAGE = 'Accept-Language';

// API にアクセスするときの API-KEY のヘッダー名
export const HEADER_NAME_FOR_CKFINDER_CSRF_TOKEN = 'X-Ckfinder-Csrf-Token';

// CKFinder の CSRF トークンのパラメータ名
export const CKFINDER_CSRF_TOKEN_KEY = 'ckCsrfToken';
